import _styled from "styled-components";
var _class, _HelpVideoPanel;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { withTheme } from "styled-components";
import Icon from "../../../../Styled/Icon";
import Styles from "./help-panel.scss";
import Spacing from "../../../../Styled/Spacing";
import Box from "../../../../Styled/Box";
import VideoGuide from "./VideoGuide";
import TrainerPane from "./TrainerPane";
import StyledHtml from "./StyledHtml";
import SatelliteGuide from "../../../Guide/SatelliteGuide";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const HELP_VIDEO_NAME = "helpVideo";
let HelpVideoPanel = observer(_class = (_HelpVideoPanel = class HelpVideoPanel extends Component {
  render() {
    const helpItemType = this.props.paneMode || "videoAndContent"; // default is video panel
    const itemSelected = this.props.viewState.selectedHelpMenuItem === this.props.itemString;
    const isExpanded = this.props.viewState.selectedHelpMenuItem !== "";
    const className = classNames({
      [Styles.videoPanel]: true,
      [Styles.isVisible]: isExpanded,
      // when the help entire video panel is invisible (hidden away to the right)
      [Styles.shiftedToRight]: !isExpanded || !this.props.viewState.showHelpMenu || this.props.viewState.topElement !== "HelpPanel"
    });
    return itemSelected && /*#__PURE__*/_jsxs("div", {
      className: className,
      children: [/*#__PURE__*/_jsx(VideoGuide, {
        viewState: this.props.viewState,
        videoLink: this.props.videoUrl,
        background: this.props.placeholderImage,
        backgroundOpacity: this.props.videoCoverImageOpacity,
        videoName: HELP_VIDEO_NAME
      }), /*#__PURE__*/_jsxs(_StyledBox, {
        centered: true,
        fullWidth: true,
        fullHeight: true,
        displayInlineBlock: true,
        paddedHorizontally: 4,
        paddedVertically: 18,
        scroll: true,
        children: [helpItemType === "videoAndContent" && /*#__PURE__*/_jsxs(_Fragment, {
          children: [this.props.videoUrl && this.props.placeholderImage && /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: Styles.videoLink,
              style: {
                backgroundImage: "linear-gradient(rgba(0,0,0,0.35),rgba(0,0,0,0.35)), url(".concat(this.props.placeholderImage, ")")
              },
              children: /*#__PURE__*/_jsx("button", {
                className: Styles.videoBtn,
                onClick: () => this.props.viewState.setVideoGuideVisible(HELP_VIDEO_NAME),
                children: /*#__PURE__*/_jsx(Icon, {
                  glyph: Icon.GLYPHS.play
                })
              })
            }), /*#__PURE__*/_jsx(Spacing, {
              bottom: 5
            })]
          }, "image"), this.props.markdownContent && /*#__PURE__*/_jsx(StyledHtml, {
            viewState: this.props.viewState,
            markdown: this.props.markdownContent
          }, "markdownContent")]
        }), helpItemType === "slider" && /*#__PURE__*/_jsx(SatelliteGuide, {
          terria: this.props.terria,
          viewState: this.props.viewState
        }), helpItemType === "trainer" && /*#__PURE__*/_jsx(TrainerPane, {
          content: this.props.content,
          terria: this.props.terria,
          viewState: this.props.viewState
        })]
      })]
    });
  }
}, _defineProperty(_HelpVideoPanel, "displayName", "HelpVideoPanel"), _defineProperty(_HelpVideoPanel, "propTypes", {
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  itemString: PropTypes.string,
  paneMode: PropTypes.string,
  markdownContent: PropTypes.string,
  videoUrl: PropTypes.string,
  placeholderImage: PropTypes.string,
  videoCoverImageOpacity: PropTypes.number,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired
}), _HelpVideoPanel)) || _class;
export default withTranslation()(withTheme(HelpVideoPanel));
var _StyledBox = _styled(Box).withConfig({
  displayName: "HelpVideoPanel___StyledBox",
  componentId: "sc-kfkzyo-0"
})(["overflow:auto;overflow-x:hidden;overflow-y:auto;"]);